import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import type { Icon } from '@onefootprint/icons';
import { IcoChevronDown16 } from '@onefootprint/icons';
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { forwardRef, useState } from 'react';
import Button from '../button';
import type { ButtonSize, ButtonVariant } from '../button/button.types';
import Dropdown from '../dropdown';
export type DropdownButtonOption = {
  label: string;
  value: string;
  onSelect: () => void;
  disabled?: boolean;
  iconLeft?: Icon;
};
export type DropdownButtonProps = {
  children: string;
  options: DropdownButtonOption[];
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  size?: ButtonSize;
  testID?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariant;
};
const chevronColorByVariant: Record<ButtonVariant, Color> = {
  primary: 'quinary',
  secondary: 'primary',
  destructive: 'quinary'
};

/* The chevron has built-in visual padding inside its 16x16 box, so we
   shave 2px off the right to balance against the left edge optically. */
const paddingRightBySize: Record<ButtonSize, string> = {
  large: '22px',
  default: '10px',
  compact: '6px'
};
const DropdownButton = forwardRef<HTMLButtonElement, DropdownButtonProps>((t0, ref) => {
  const $ = _c(25);
  const {
    children,
    className,
    disabled: t1,
    loading: t2,
    options,
    size: t3,
    testID,
    type: t4,
    variant: t5
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const loading = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "default" : t3;
  const type = t4 === undefined ? "button" : t4;
  const variant = t5 === undefined ? "primary" : t5;
  const [open, setOpen] = useState(false);
  const t6 = disabled || loading;
  const t7 = chevronColorByVariant[variant];
  const t8 = paddingRightBySize[size];
  let t9;
  if ($[0] !== t8) {
    t9 = {
      paddingRight: t8
    };
    $[0] = t8;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  let t10;
  if ($[2] !== children || $[3] !== className || $[4] !== disabled || $[5] !== loading || $[6] !== ref || $[7] !== size || $[8] !== t7 || $[9] !== t9 || $[10] !== testID || $[11] !== type || $[12] !== variant) {
    t10 = <Button className={className} disabled={disabled} iconColor={t7} loading={loading} ref={ref} size={size} style={t9} suffixIcon={IcoChevronDown16} testID={testID} type={type} variant={variant}>{children}</Button>;
    $[2] = children;
    $[3] = className;
    $[4] = disabled;
    $[5] = loading;
    $[6] = ref;
    $[7] = size;
    $[8] = t7;
    $[9] = t9;
    $[10] = testID;
    $[11] = type;
    $[12] = variant;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t6) {
    t11 = <RadixDropdown.Trigger asChild={true} disabled={t6}>{t10}</RadixDropdown.Trigger>;
    $[14] = t10;
    $[15] = t6;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== options) {
    t12 = options.map(_temp);
    $[17] = options;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12) {
    t13 = <Dropdown.Portal><Dropdown.Content align="start" sideOffset={6}><Dropdown.Group>{t12}</Dropdown.Group></Dropdown.Content></Dropdown.Portal>;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== open || $[22] !== t11 || $[23] !== t13) {
    t14 = <Dropdown.Root open={open} onOpenChange={setOpen}>{t11}{t13}</Dropdown.Root>;
    $[21] = open;
    $[22] = t11;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
});
export default DropdownButton;
function _temp(option) {
  return <Dropdown.Item key={option.value} iconLeft={option.iconLeft} disabled={option.disabled} onSelect={option.onSelect}>{option.label}</Dropdown.Item>;
}